export const gtagMap = {
  AU: 'G-4JFSVXJZVS',
  US: 'G-4N079SVHPH',
  NZ: 'G-HXB1LZ6XMC',
  GB: 'G-TFVX71PJQ6',
};
